(() => {
  'use strict';
  const FORM_ID = 'Uy2v2r';
  const END = Date.parse('2026-12-31T23:59:59+01:00');
  const DISMISSED = 'nw:competition2026:dismissed';
  const ENTERED = 'nw:competition2026:entered';
  const NEWSLETTER = 'nw:newsletter:registered';
  const PREVIEW = 'nw:competition2026:preview-open';
  const COOLDOWN = 7 * 24 * 60 * 60 * 1000;
  const MIN_TIME = 60000;
  const popup = document.querySelector('[data-competition-popup]');
  const hosts = [...document.querySelectorAll('[data-competition-form]')];
  let started = performance.now();
  let requesting = false;
  let shownThisPage = false;
  let previousFocus;
  let otherKlaviyoOpen = false;
  const read = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, String(value)); } catch (_) {} };
  const remove = key => { try { localStorage.removeItem(key); } catch (_) {} };
  const sessionSave = value => { if (window.__fudgeDebug) { try { sessionStorage.setItem(PREVIEW, value ? '1' : '0'); } catch (_) {} } };
  const visible = element => !!(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none');
  const desktop = () => matchMedia('(min-width:1024px) and (hover:hover) and (pointer:fine)').matches;
  const entered = () => read(ENTERED) === '1';
  const eligibleTime = () => performance.now() - started >= MIN_TIME;
  const suppressed = () => entered() || read(NEWSLETTER) === '1' || Date.now() - Number(read(DISMISSED) || 0) < COOLDOWN;
  function collision() {
    if (otherKlaviyoOpen) return true;
    if (visible(document.querySelector('[data-testid="klaviyo-form-W4NSKm"]')) && document.body.classList.contains('klaviyo-prevent-body-scrolling')) return true;
    return [...document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], .popup--open, .drawer--open')].some(el => el !== popup && !popup?.contains(el) && visible(el));
  }
  const loaded = () => !!popup?.querySelector('form[data-testid="klaviyo-form-Uy2v2r"]');
  const basics = () => !!popup && desktop() && document.visibilityState === 'visible' && Date.now() <= END && !suppressed() && !shownThisPage && eligibleTime() && !collision() && loaded();
  function closePopup(dismiss = true) {
    if (!popup?.open) return;
    if (dismiss) save(DISMISSED, Date.now());
    popup.close();
    sessionSave(false);
    previousFocus?.focus?.({ preventScroll: true });
  }
  function displayPopup() {
    if (!popup || popup.open || typeof popup.showModal !== 'function') return false;
    previousFocus = document.activeElement;
    popup.showModal();
    shownThisPage = true;
    sessionSave(true);
    const input = popup.querySelector('input:not([type="hidden"])');
    (input || popup.querySelector('[data-competition-close]'))?.focus({ preventScroll: true });
    return true;
  }
  async function tryOpen() {
    if (requesting || !basics()) return false;
    requesting = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) return false;
      const cart = await response.json();
      if (cart.item_count !== 0 || !basics()) return false;
      return displayPopup();
    } catch (_) { return false; }
    finally { requesting = false; }
  }
  function resetPreview() {
    closePopup(false);
    [DISMISSED, ENTERED, NEWSLETTER].forEach(remove);
    shownThisPage = false;
    started = performance.now();
    hosts.forEach(host => {
      host.querySelector('[data-competition-success]').hidden = true;
      host.querySelector('.klaviyo-form-Uy2v2r').hidden = false;
      host.querySelector('.nw-competition-consent').hidden = false;
      host.querySelector('.nw-competition-legal').hidden = false;
      host.querySelector('[data-form-status]').hidden = !!host.querySelector('.klaviyo-form-Uy2v2r form');
    });
  }
  // Preview-only state controls; optional chaining keeps them off the live store.
  window.__fudgeDebug?.action('Vis konkurrencepopup', () => displayPopup());
  window.__fudgeDebug?.action('Luk konkurrencepopup', () => closePopup(false));
  window.__fudgeDebug?.action('Nulstil konkurrencetest', resetPreview);
  window.__fudgeDebug?.command('Konkurrencestatus', () => ({ elapsedMs: performance.now() - started, desktop: desktop(), loaded: loaded(), suppressed: suppressed(), collision: collision(), shownThisPage, open: !!popup?.open, expired: Date.now() > END }));
  window.__fudgeDebug?.command('Afprøv konkurrencepopup', tryOpen);
  document.addEventListener('mouseleave', event => { if (event.clientY <= 0) tryOpen(); });
  window.addEventListener('pageshow', event => { if (event.persisted) { started = performance.now(); closePopup(false); shownThisPage = false; } });
  popup?.addEventListener('cancel', event => { event.preventDefault(); closePopup(true); });
  popup?.querySelectorAll('[data-competition-close]').forEach(button => button.addEventListener('click', () => closePopup(true)));
  popup?.addEventListener('click', event => {
    if (event.target !== popup) return;
    const rect = popup.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePopup(true);
  });
  window.addEventListener('resize', () => { if (!desktop()) closePopup(false); });
  function showSuccess(host) {
    host.querySelector('[data-competition-success]').hidden = false;
    host.querySelector('[data-form-status]').hidden = true;
    host.querySelector('.klaviyo-form-Uy2v2r').hidden = true;
    host.querySelector('.nw-competition-consent').hidden = true;
    host.querySelector('.nw-competition-legal').hidden = true;
  }
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (detail.formId !== FORM_ID) {
      if (detail.type === 'open') { otherKlaviyoOpen = true; closePopup(false); }
      if (detail.type === 'close') otherKlaviyoOpen = false;
      if (detail.type === 'submit') save(NEWSLETTER, '1');
      return;
    }
    // Only Klaviyo's completed form submit event counts. Never clicks or stepSubmit.
    if (detail.type === 'submit') {
      save(ENTERED, '1');
      save(NEWSLETTER, '1');
      hosts.forEach(showSuccess);
      document.querySelectorAll('.nw-competition-teaser').forEach(el => { el.hidden = true; });
    }
  });
  if (entered()) {
    hosts.forEach(showSuccess);
    document.querySelectorAll('.nw-competition-teaser').forEach(el => { el.hidden = true; });
  }
  hosts.forEach(host => {
    const embed = host.querySelector('.klaviyo-form-Uy2v2r');
    const status = host.querySelector('[data-form-status]');
    const refresh = () => {
      if (embed.querySelector('form')) status.hidden = true;
    };
    const observer = new MutationObserver(refresh);
    observer.observe(embed, { childList: true, subtree: true });
    refresh();
    setTimeout(() => {
      if (!embed.querySelector('form') && !entered()) status.textContent = 'Tilmeldingen er ikke tilgængelig lige nu. Prøv igen senere.';
    }, 12000);
  });
  document.querySelectorAll('a[href$="#konkurrencevilkaar"]').forEach(link => link.addEventListener('click', () => {
    const details = document.getElementById('konkurrencevilkaar');
    if (details) details.open = true;
  }));
  if (location.hash === '#konkurrencevilkaar') {
    const details = document.getElementById('konkurrencevilkaar');
    if (details) details.open = true;
  }
  if (window.__fudgeDebug && popup) {
    try { if (sessionStorage.getItem(PREVIEW) === '1') displayPopup(); } catch (_) {}
  }
})();
